import angular from 'angular';
import BodycodeController from './bodycodes.controller';
import Routes from './bodycodes.routes';

import './bodycodes.styles.scss';

export default angular.module('autoboard.bodycodes', [])
  .config(Routes)
  .controller('BodycodeController', BodycodeController)
  .name;
